<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 48 48"
        preserveAspectRatio="xMidYMid meet">
        <defs>
            <clipPath :id="`clip-path-${uniqueId}`">
                <rect id="Rectangle_238" data-name="Rectangle 238" width="48" height="48" rx="6" fill="#fff" />
            </clipPath>
        </defs>
        <g
            id="Icons_I_payment_transparent_maestro"
            data-name="Icons / I_payment_transparent_maestro"
            :clip-path="`url(#clip-path-${uniqueId})`">
            <rect id="Rectangle_236" data-name="Rectangle 236" width="48" height="48" rx="6" fill="rgba(0,0,0,0)" />
            <rect
                id="Rectangle_237"
                data-name="Rectangle 237"
                width="46"
                height="46"
                rx="5.5"
                transform="translate(1 1)"
                fill="none"
                stroke="rgba(255,255,255,0)"
                stroke-width="1" />
            <g id="Group_1434" data-name="Group 1434" transform="translate(9 15)">
                <path
                    id="Path_292"
                    data-name="Path 292"
                    d="M13.617,25.5a9,9,0,0,0,0-18,9,9,0,1,0,0,18Z"
                    transform="translate(-4.5 -7.5)"
                    fill="#ff000f"
                    fill-rule="evenodd" />
                <path
                    id="Path_293"
                    data-name="Path 293"
                    d="M19.617,25.5a9,9,0,0,0,0-18,9,9,0,1,0,0,18Z"
                    transform="translate(1.5 -7.5)"
                    fill="#00a2e1"
                    fill-rule="evenodd" />
                <path
                    id="Path_294"
                    data-name="Path 294"
                    d="M13.518,8.652A9.079,9.079,0,0,0,10.5,15.465a8.784,8.784,0,0,0,3.018,6.6,8.878,8.878,0,0,0,2.982-6.6A9.178,9.178,0,0,0,13.518,8.652Z"
                    transform="translate(1.5 -6.348)"
                    fill="#e7001a"
                    fill-rule="evenodd"
                    opacity="0.3" />
            </g>
            <g
                id="Group_1435"
                data-name="Group 1435"
                transform="translate(9 15)"
                style="mix-blend-mode: color; isolation: isolate">
                <path
                    id="Path_292-2"
                    data-name="Path 292"
                    d="M13.617,25.5a9,9,0,0,0,0-18,9,9,0,1,0,0,18Z"
                    transform="translate(-4.5 -7.5)"
                    fill="#bfbca5"
                    fill-rule="evenodd" />
                <path
                    id="Path_293-2"
                    data-name="Path 293"
                    d="M19.617,25.5a9,9,0,0,0,0-18,9,9,0,1,0,0,18Z"
                    transform="translate(1.5 -7.5)"
                    fill="#bfbca5"
                    fill-rule="evenodd" />
                <path
                    id="Path_294-2"
                    data-name="Path 294"
                    d="M13.518,8.652A9.079,9.079,0,0,0,10.5,15.465a8.784,8.784,0,0,0,3.018,6.6,8.878,8.878,0,0,0,2.982-6.6A9.178,9.178,0,0,0,13.518,8.652Z"
                    transform="translate(1.5 -6.348)"
                    fill="#bfbca5"
                    fill-rule="evenodd"
                    opacity="0.3" />
            </g>
        </g>
    </svg>
</template>

<script lang="ts" setup>
    const uniqueId = useId();
</script>
